import { RoutePath } from "@src/interfaces";
import { useNavigate } from "react-router-dom";
import { ChevronDownIcon } from "@src/assets";
import { IconWithTooltip } from "../IconWithTooltip";
import { Chain } from "@src/models";

type Props = {
  chain?: Chain;
  shouldUseTransferToken?: boolean;
};

export const ChainPickerCard = ({
  chain,
  shouldUseTransferToken = false,
}: Props) => {
  const navigate = useNavigate();

  return (
    <div
      aria-label="Chain picker"
      className="px-4 py-2 flex justify-between items-center bg-card_bg rounded-xl cursor-pointer"
      onClick={() => {
        navigate(RoutePath.PickChain, {
          state: { shouldUseTransferToken },
        });
      }}
    >
      <div className="flex gap-1 items-center">
        <img src={chain?.image} alt={chain?.name} className="w-4 h-4" />
        <div className="flex gap-2 items-center">
          <p className="text-sm text-x-purple-500 capitalize font-bold">
            {chain?.name}
            {" Network"}
          </p>
          <IconWithTooltip
            tooltipText={`A "network" is a blockchain where digital tokens (like cryptocurrencies) are stored and transferred`}
            id="chain-tooltip"
          />
        </div>
      </div>
      <ChevronDownIcon />
    </div>
  );
};
